// extracted by mini-css-extract-plugin
export var menuItem = "x_t1 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "x_t2 d_Z d_bz d_bP";
export var menuMainLink = "x_t3 d_f0 d_dB";
export var menuLink = "x_t4 d_f0 d_dB";
export var icon = "x_p9 d_bC d_bP";
export var divider = "x_t5 d_bC d_bP";
export var sublinks = "x_t6";
export var link = "x_mZ";
export var Link = "x_rz p_rz p_qN p_q6";